import * as _ from 'lodash';
import * as api from './../../api/api.service';

import OfferImpactService from './../OfferImpact.service';

import { Seller } from './offerImpactForBuyer.component';

export default class BuyerOfferImpactService extends OfferImpactService {
  purchasePlanningPermissions;
  attachments;
  featureList;
  spendBySpendLevelFieldName;

  constructor(
    $http,
    jsendHttpInterceptor,
    $q,
    api: api.IApiService,
    colors,
    LoadingIndicator,
    $routeParams,
    $filter,
  ) {
    'ngInject';

    super(
      $http,
      jsendHttpInterceptor,
      $q,
      api,
      colors,
      LoadingIndicator,
      $routeParams,
    );

    this.spendBySpendLevelFieldName = $filter('spendBySpendLevelFieldName');
  }

  getAttachments(rfpId) {
    this.api.rfps.getAttachments(rfpId).then((data) => {
      return this.attachments.push(...data);
    });
  }

  loadAccount() {
    let loader = this.api.users.currentUser();

    this.LoadingIndicator.waitFor(loader);

    return loader;
  }

  loadFeatures() {
    let loader = this.api.features.getFeatures();

    this.LoadingIndicator.waitFor(loader);

    loader.then((featureList) => {
      this.featureList = featureList;
    });

    return loader;
  }

  loadRfp(rfpId) {
    let loader = this.api.rfps.getRfp(rfpId, true);

    this.LoadingIndicator.waitFor(loader);

    return loader;
  }

  /**
   * Sort and map the sellers in the seller info
   */
  mapSellers(sellerInfo) {
    return _.map(sellerInfo, (seller: any) => {
      return {
        id: seller.sellerId,
        name: seller.sellerName,
        offerId: seller.offerId,
        offerName: seller.offerName,
        plannedSpendLevel: seller.plannedSpendLevel,
        targetMarketShare: seller.targetMarketShare,
      };
    });
  }

  sortSellersByName(sellers): Seller[] {
    return _.sortBy(sellers, (seller) => {
      return seller.name;
    });
  }

  /**
   * Rename the properties from the backend to our naming
   */
  mapMembers(memberImpacts) {
    return _.map(memberImpacts, (memberImpact: any) => {
      return {
        id: memberImpact.memberId,
        name: memberImpact.memberName,
        combinedMarketShare: memberImpact.combinedMarketShare,
        memberPlanId: memberImpact.memberPlanId,
        sellerImpacts: memberImpact.sellerImpact,
      };
    });
  }

  getMemberData(memberId, masterPlanId) {
    let loader = this.api.buyers.getMemberImpact(memberId, masterPlanId);
    this.LoadingIndicator.waitFor(loader);
    return loader;
  }

  getMemberDataAndUpdateSpend(member, masterPlanId, activeSeller) {
    this.getMemberData(member.id, masterPlanId).then((memberImpact) => {
      member.sellerImpacts = memberImpact.sellerImpact;

      this.updateMemberSpendForSeller(member, activeSeller);
    });
  }

  updateMemberSpendForSeller(member, activeSeller) {
    if (member.sellerImpacts && member.sellerImpacts.length > 0) {
      let activeSellerImpact = _.find(member.sellerImpacts, {
        sellerId: activeSeller.id,
      }) as any;

      // The pucks components need these fields on the top level for now
      member.plannedSpend = activeSellerImpact.plannedSpend;
      member.complianceSpend = activeSellerImpact.complianceSpend;
      member.savings = activeSellerImpact.savings;
      member.continuedSpend = activeSellerImpact.continuedSpend;
      member.meetsTargetMarketShare = activeSellerImpact.meetsTargetMarketShare;

      // These values are broken - but correcting them causes issues with the charts.
      // We nee to figure out what new source to use for the values.
      // member.allocatedMarketShare = this.offerTypeHelper.getAllocatedMarketShare(activeSellerImpact.plannedSpendLevel);
      // member.targetMarketShare = this.offerTypeHelper.getAllocatedMarketShare(activeSellerImpact.targetSpendLevel);

      // member.spendBenchmark = activeSellerImpact.spendBenchmark;
      member.activeSellerImpact = activeSellerImpact;
      member.conversionsNeededCount = activeSellerImpact.conversionsNeededCount;
      member.inclusionModifiedBy = activeSellerImpact.inclusionModifiedBy;
      member.activeSeller = activeSeller;
    }

    return member;
  }

  /**
   * Go through each member and get the seller impact for the active seller
   */
  getSellerImpacts(members, activeSeller) {
    let sellerImpacts = [];

    _.each(members, (member: any) => {
      // These get loaded async for each member, so they may be empty initially, but they'll load eventually
      if (member.sellerImpacts && member.sellerImpacts.length > 0) {
        let sellerImpact = _.find(member.sellerImpacts, {
          sellerId: activeSeller.id,
        });

        sellerImpacts.push(sellerImpact);
      }
    });

    return sellerImpacts;
  }

  // Only used by buyer side code
  setPurchasePlanningPermissions(permissions) {
    this.purchasePlanningPermissions = permissions;
  }

  canInOut(account, permissions, orgId) {
    // let permissions = this.purchasePlanningPermissions;

    // console.log(permissions.OPT_IN_OUT);
    // console.log(orgId);

    // backend needs to add another permission for opt in/out partners
    return (
      permissions &&
      permissions.OPT_IN_OUT &&
      (this.isLeader(account) || orgId === account.organization.id)
    );
  }

  // Kemi is updating this endpoint so we can move these calls to the api -- see BEND-488
  setAllSystemsToIn(masterPlanId, sellerId, included) {
    // Needs to be replaced once BEND-488 gives us a new API to call.
    return this.$http.post(
      '/aptitude/buyer/GroupImpactServiceController/setInclusionFlagAllMembers',
      {
        masterPlanId: masterPlanId,
        sellerId: sellerId,
        included: included,
      },
      {
        intercept: true,
        postEncoding: 'legacy',
      },
    );
  }

  setSystemStatus(masterPlanId, memberId, sellerId, included) {
    // Needs to be replaced once BEND-488 gives us a new API to call.
    return this.$http.post(
      '/aptitude/buyer/GroupImpactServiceController/setInclusionFlag',
      {
        masterPlanId: masterPlanId,
        memberId: memberId,
        sellerId: sellerId,
        included: included,
      },
      {
        intercept: true,
        postEncoding: 'legacy',
      },
    );
  }
}
